<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn v-if="inEditMode && bank.id != 0" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="bank.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="255"
                                    v-model="bank.name"
                                    :errorBorder="!bankValidation.name"
                                    :label="'* ' + $t('fields.name')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="12">
                                <TextArea
                                    :readonly="!inEditMode"
                                    :maxlength="255"
                                    v-model="bank.address"
                                    :errorBorder="!bankValidation.address"
                                    :label="'* ' + $t('fields.address')"
                                ></TextArea>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="50"
                                    :readonly="!inEditMode"
                                    v-model="bank.city"
                                    :errorBorder="!bankValidation.city"
                                    :label="'* ' + $t('fields.city')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="20"
                                    :readonly="!inEditMode"
                                    v-model="bank.post_code"
                                    :errorBorder="!bankValidation.post_code"
                                    :label="'* ' + $t('fields.postalCode')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="bank.country_id"
                                    :ajax="true"
                                    :data="'countries'"
                                    :errorBorder="!bankValidation.country_id"
                                    :label="'* ' + $t('fields.country')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :maxlength="30"
                                    :readonly="!inEditMode"
                                    v-model="bank.swift_code"
                                    :errorBorder="!bankValidation.swift_code"
                                    :label="'* ' + $t('fields.swiftCode')"
                                ></InputField>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import InputField from './trinkets/InputField';
import Bank from '../models/Bank';
import TextArea from '@/components/trinkets/TextArea';

export default {
    name: 'Bank',
    components: {CheckBox, Dropdown, InputField, TextArea},
    data: function () {
        return {
            bank: new Bank({id: this.$route.params.id}),
            bankValidation: new Bank({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'bank',
            lockTimer: null,
        };
    },
    methods: {
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.bank.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.bank.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },

        backClick() {
            this.$router.go(-1);
        },
        saveClick(goBack) {
            let success = true;
            if (this.bank.name == '') {
                success = false;
                this.bankValidation.name = false;
            } else {
                this.bankValidation.name = true;
            }

            if (this.bank.address == '') {
                success = false;
                this.bankValidation.address = false;
            } else {
                this.bankValidation.address = true;
            }

            if (this.bank.city == '') {
                success = false;
                this.bankValidation.city = false;
            } else {
                this.bankValidation.city = true;
            }

            if (this.bank.post_code == '') {
                success = false;
                this.bankValidation.post_code = false;
            } else {
                this.bankValidation.post_code = true;
            }

            if (this.bank.swift_code == '') {
                success = false;
                this.bankValidation.swift_code = false;
            } else {
                this.bankValidation.swift_code = true;
            }

            if (this.bank.country_id == null) {
                success = false;
                this.bankValidation.country_id = false;
            } else {
                this.bankValidation.country_id = true;
            }
            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.bank.id != 0) {
                    action = 'put';
                    addition = '/' + vm.bank.id;
                }
                this.$APICall(action, 'banks' + addition, this.bank, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.bank.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        if (this.lockTimer !== null) clearInterval(this.lockTimer);
                        vm.$removeLock(vm, vm.lockKey + '|' + vm.bank.id);
                        vm.$triggerReload();
                        if (goBack) {
                            vm.backClick();
                        }
                    }
                });
            }
        },
    },

    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.bank.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.bank.id != 0) {
            this.$APICall('get', 'banks/' + this.bank.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.bank = usableData;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.banks'),
                            href: '/#/banks',
                            disabled: false,
                        },
                        {
                            text: vm.bank.name,
                            href: '/#/banks/' + vm.bank.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.banks'),
                    href: '/#/banks',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newBank'),
                    href: '/#/bank/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
